// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tvYP","colBig":"styles_colBig__iS_bF","colSmall":"styles_colSmall__ukiut"};